/**
 * Wires a modal whose submit button should only enable once one of two
 * mutually-exclusive radio inputs is selected, and disables it the instant
 * the form is submitted so a double-click (or a slow response) cannot fire
 * a second POST.
 *
 * Callers that need to react to the selection themselves (toggling
 * conditional fields, setting `required`) pass `onChange`, invoked with
 * which radio is checked whenever either one changes.
 */
export function initExclusiveRadioSubmitGuard(
    modal: HTMLElement,
    radioAId: string,
    radioBId: string,
    submitBtnId: string,
    onChange?: (isA: boolean, isB: boolean) => void,
): void {
    const radioA = modal.querySelector<HTMLInputElement>(`#${radioAId}`);
    const radioB = modal.querySelector<HTMLInputElement>(`#${radioBId}`);
    const submitBtn = modal.querySelector<HTMLButtonElement>(`#${submitBtnId}`);
    const form = modal.querySelector<HTMLFormElement>('form');

    if (!submitBtn) return;
    const btn = submitBtn;

    function update(): void {
        const isA = radioA?.checked === true;
        const isB = radioB?.checked === true;
        btn.disabled = !(isA || isB);
        onChange?.(isA, isB);
    }

    radioA?.addEventListener('change', update);
    radioB?.addEventListener('change', update);

    // Native full-page-reload POST: disabling here only blocks a second click
    // after this one is already underway, so the browser still submits this
    // (first) request normally.
    form?.addEventListener('submit', () => {
        btn.disabled = true;
    });
}
